import * as CollapsiblePrimitive from '@radix-ui/react-collapsible'

import { cn } from '@/lib/ui/style-helpers'

export const CollapsibleTrigger = ({
  className,
  ...props
}: React.ComponentProps<typeof CollapsiblePrimitive.CollapsibleTrigger>) => (
  <CollapsiblePrimitive.CollapsibleTrigger
    data-slot='collapsible-trigger'
    // Radix defaults `disabled` from Root context and our spread would override it,
    // so `disabled` is left to pass through untouched.
    className={cn({ 'cursor-pointer': !props.disabled }, className)}
    {...props}
  />
)
